import { UserApi } from '../models';
import { useGetUserByIdQuery } from '../services/users.service';

type UseUserProps = {
  userId: string;
};

const useUser = ({ userId }: UseUserProps) => {
  const { data, isLoading, error } = useGetUserByIdQuery({ userId });

  return { data, isLoading, error, user: data || {} as UserApi};
};

export default useUser;
